var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.pageFullyLoaded)?[(!_vm.isLoggedIn)?_c('logged-out-layout'):_c('main-layout')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }